import ContractManage from './contract_manage.vue';

export default ContractManage;
